import { ParticleAttributes } from "./particle.shader";
export class InstanceParticle {
    constructor(batch, instanceIndex) {
        this.batch = batch;
        this.instanceIndex = instanceIndex;
    }
    isValid() {
        return this.batch && this.instanceIndex !== -1;
    }
    get geometry() {
        return this.batch.geometry;
    }
    get visible() {
        if (this.isValid()) {
            return this.isVisible();
        }
        return false;
    }
    set visible(value) {
        if (this.isValid()) {
            this.setVisible(value);
        }
    }
    isVisible() {
        return this.batch.isVisibleAt(this.instanceIndex);
    }
    setVisible(value) {
        this.batch.setVisibleAt(this.instanceIndex, value);
    }
    // World position
    setPosition(pos) {
        this.batch.setVector3AttributeAt(ParticleAttributes.position, this.instanceIndex, pos);
    }
    // World position
    getPosition(pos) {
        this.batch.getVector3AttributeAt(ParticleAttributes.position, this.instanceIndex, pos);
    }
    setOffset(x, y, z, w) {
        this.batch.setAttributeAt(ParticleAttributes.offset, this.instanceIndex, [x, y, z, w]);
    }
    destroy() {
        this.batch.deleteInstance(this);
    }
}
